import { DOC_TEMPLATES } from '@baserow/modules/core/docTemplates'

/**
 * Origem Flow: ordenação da lista de documentos (sidebar e hub de Docs),
 * escolhida pelo botão direito na pasta "Documentos" e persistida no
 * localStorage. Valores: 'recent' (padrão), 'alphabetical', 'type' e
 * 'manual' (ordem definida arrastando; entra automaticamente ao arrastar).
 */
const STORAGE_KEY = 'origemFlowDocsSortBy'

export const DOCS_SORT_OPTIONS = ['recent', 'alphabetical', 'type', 'manual']

export function readDocsSort() {
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    return DOCS_SORT_OPTIONS.includes(value) ? value : 'recent'
  } catch (error) {
    return 'recent'
  }
}

export function writeDocsSort(value) {
  try {
    localStorage.setItem(STORAGE_KEY, value)
  } catch (error) {
    // Sem localStorage a escolha só não persiste entre sessões.
  }
}

export function docTypeLabel(docType, blankLabel = '') {
  const template = DOC_TEMPLATES.find((t) => t.key === docType)
  return template ? template.name : blankLabel
}

export function docTypeIcon(docType) {
  const template = DOC_TEMPLATES.find((t) => t.key === docType)
  return template ? template.icon : 'iconoir-page'
}

export function sortDocuments(documents, sortBy, { blankLabel = '' } = {}) {
  const byName = (a, b) =>
    (a.name || '').localeCompare(b.name || '', undefined, {
      sensitivity: 'base',
    })
  const sorted = [...documents]
  if (sortBy === 'manual') {
    sorted.sort((a, b) => (a.order || 0) - (b.order || 0) || a.id - b.id)
  } else if (sortBy === 'alphabetical') {
    sorted.sort(byName)
  } else if (sortBy === 'type') {
    sorted.sort(
      (a, b) =>
        docTypeLabel(a.doc_type, blankLabel).localeCompare(
          docTypeLabel(b.doc_type, blankLabel),
          undefined,
          { sensitivity: 'base' }
        ) || byName(a, b)
    )
  } else {
    sorted.sort((a, b) => new Date(b.updated_on) - new Date(a.updated_on))
  }
  return sorted
}
